import React, { useState } from "react";
import { createData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";

function AddPaymentMethod({ setIsLoading, setAddtab, fetchPaymentMethods }) {
  const [formData, setFormData] = useState({
    method_name: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("payment-methods/store", formData);
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      setLoading(false);
      setAddtab(false);
      fetchPaymentMethods();
    }
  };

  return (
    <div className="bg-white  p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setAddtab(false)}
        />
      </div>
      <h3 className="text-2xl font-medium text-center">
        Add New Payment Method
      </h3>
      <form
        onSubmit={handleSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col  justify-center lg:flex-row gap-6 ">
          <div className="flex flex-col">
            <label htmlFor=""> Payment Method Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Name"
              type="text "
              name="method_name"
              value={formData.method_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500 hover:bg-blue-600"
        >
          {loading ? "Adding Method..." : "Add Method"}
        </button>
      </form>
    </div>
  );
}

export default AddPaymentMethod;
